import DashboardLayout from "./Components/Invoice/Dashboard";
export default function Plans() {
  return (
    <DashboardLayout>
    <div>
      <h1 className="text-2xl font-bold">All Plans</h1>
      <p>Here you will display saved plans from backend.</p>
    </div>
    </DashboardLayout>
  );
}